<ul class="property-block__list">
    <li class="property-block__list-item">
        <div class="property-block__label" id="active">Beginning Grade</div>
        <div class="property-block__value" role="definition" aria-labelledby="active">{{ beginningGrade }}</div>
    </li>
    <li class="property-block__list-item">
        <div class="property-block__label" id="shortName">Estimated Beginners</div>
        <div class="property-block__value" role="definition" aria-labelledby="shortName">{{ program.numberBeginningMusicians }}</div>
    </li>
    <li class="property-block__list-item">
        <div class="property-block__label" id="shortName">Estimated School Owned Instruments</div>
        <div class="property-block__value" role="definition" aria-labelledby="shortName">{{ program.numberSchoolInstruments }}</div>
    </li>
    <li class="property-block__list-item">
        <div class="property-block__label" id="shortName">Rental Flyers</div>
        <div class="property-block__value" role="definition" aria-labelledby="shortName">{{ rentalFlyers }}</div>
    </li>
</ul>
